import { Flex, IconButton, Link, Tooltip } from '@lego/klik-ui';
import { CheckTickBold, Clone } from '@lego/klik-ui/icons';
import type { MouseEvent } from 'react';
import { useCopyToClipboard } from '@/hooks/common/useCopyToClipboard';

type Props = {
  value: string;
  url: string;
};

export const CopyableLink = ({ value, url }: Props) => {
  const { copied, error, copy } = useCopyToClipboard();

  const handleCopy = async (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    await copy(value);
  };

  const getTooltipLabel = () => {
    if (copied) return 'Copied!';
    if (error) return 'Copy failed';
    return 'Copy full value';
  };

  return (
    <Flex align="center" gap={1}>
      <Tooltip label={value}>
        <Link
          display="block"
          href={url}
          isExternal
          overflow="hidden"
          padding={0}
          textOverflow="ellipsis"
          whiteSpace="nowrap"
        >
          {value}
        </Link>
      </Tooltip>
      <Tooltip
        isOpen={copied || error ? true : undefined}
        key={copied ? 'copied' : error ? 'error' : 'copy'}
        label={getTooltipLabel()}
      >
        <IconButton
          aria-label="Copy value"
          icon={copied ? <CheckTickBold color="green" /> : <Clone />}
          onClick={handleCopy}
          size="xs"
          variant="ghost"
        />
      </Tooltip>
    </Flex>
  );
};
